import React, { useState, useContext, useCallback } from "react"
import ReactGA from "react-ga"
import { Global } from "@emotion/core"
import { useLocation } from "@reach/router"
import { useStaticQuery, graphql } from "gatsby"
import { Box, ThemeProvider, Styled } from "theme-ui"
import Helmet from "react-helmet"

import { Header } from "./Header"
import { Footer } from "./Footer"
import { Cart } from "./Cart"
import { EmailModal } from "./EmailModal"
import { NoteModal } from "./NoteModal"
import SEO from "./seo"

import { Context } from "../context/MainContext"

import theme from "../gatsby-plugin-theme-ui/index"
import useEventListener from "../hooks/useEventListener"

import { isBrowser } from "../util"
import "./reset.css"
import "./base.css"

const initializeReactGA = googleAnalyticsId => {
  ReactGA.initialize(googleAnalyticsId)
  if (isBrowser) {
    ReactGA.pageview(window.location.pathname + window.location.search)
  }
}

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query LayoutQuery {
      site {
        siteMetadata {
          googleAnalyticsId
        }
      }
    }
  `)

  const { googleAnalyticsId } = data.site.siteMetadata

  initializeReactGA(googleAnalyticsId)

  return (
    <ThemeProvider theme={theme}>
      <Styled.root>
        <LayoutComponents>{children}</LayoutComponents>
      </Styled.root>
    </ThemeProvider>
  )
}

const LayoutComponents = ({ children }) => {
  const [colorIndex, setColorIndex] = useState(0)
  const location = useLocation()
  const root = location.pathname === "/"
  const background = "linear-gradient(-180deg, #ccc2ba 0%, #eea33b 100%)"

  const seletionColors = ["#CCC2BA", "#EFDEC5", "#D4E0B8", "#F7E8A0", "#EEA33B"]

  const styles = {
    root: {
      position: "relative",
      background: !root ? background : null,
    },
  }

  const {
    store: { isMobile },
  } = useContext(Context)

  const selectionHandler = useCallback(() => {
    setColorIndex(Math.floor(Math.random() * seletionColors.length))
  }, [seletionColors, setColorIndex])

  useEventListener("mousedown", selectionHandler)

  return (
    <Box sx={styles.root}>
      <Helmet>
        <script
          async
          type="text/javascript"
          src="https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=Sv9s8h"
        ></script>
      </Helmet>
      <Global
        styles={{
          "*": {
            "::selection": {
              color: "#333333",
              backgroundColor: seletionColors[colorIndex],
            },
          },
        }}
      />
      <SEO />
      {/* <EmailModal /> */}
      <NoteModal />
      <Cart />
      <Header isMobile={isMobile} fixed={!root} />
      <Box as="main">{children}</Box>
      <Footer transparent={!root} />
    </Box>
  )
}

export default Layout
